import { useEffect } from "react";

import { NetworkStatus, useQuery } from "@apollo/client";

import {
  GetDevicesMakesQuery,
  GetDevicesMakesQueryVariables,
} from "../../../../../API";
import { GET_DEVICES_MAKES } from "../../../../../common/operations/queries";
import { DEFAULT_LIMIT_COUNT } from "../../../../../common/variables/common";
import { errorNotification } from "../../../../../common/variables/notification";

export const useGetDevicesMakesCached = () => {
  const { data, fetchMore, loading, networkStatus } = useQuery<
    GetDevicesMakesQuery,
    GetDevicesMakesQueryVariables
  >(GET_DEVICES_MAKES, {
    variables: { limit: DEFAULT_LIMIT_COUNT },
    notifyOnNetworkStatusChange: true,
  });

  // Load all pages when the initial data is fetched and there's a nextToken
  useEffect(() => {
    if (!data?.getDevicesMakes?.nextToken) return;

    const fetchAllPages = async () => {
      let currentNextToken = data.getDevicesMakes.nextToken;

      try {
        while (currentNextToken) {
          const response = await fetchMore({
            variables: {
              limit: DEFAULT_LIMIT_COUNT,
              nextToken: currentNextToken,
            },
          });

          currentNextToken = response.data?.getDevicesMakes?.nextToken || "";
        }
      } catch (error) {
        console.error("Error fetching additional device makes pages:", error);

        errorNotification();
      }
    };

    fetchAllPages();
  }, [data?.getDevicesMakes?.nextToken]);

  return {
    data,
    loading: loading || networkStatus === NetworkStatus.fetchMore,
  };
};
